export enum EmailTemplateType {
  All = 0,
  CancelInvoice = 1,
  ReturnToSupplier = 2,
}
